import { SubPrice } from '../subPrice/types';

export enum HostActionEnum {
  REQUEST_HOST = 'REQUEST_HOST',
  RESULT_HOST = 'RESULT_HOST',
  ERROR_HOST = 'ERROR_HOST'
}

export interface IHostFeedback {
  id: number | string;
  created_at: string;
  description: string;
  rates: number;
  photo: string[];
  link: string;
  order_id: number;
  host_id: number;
  van_id: number;
  client_name: string;
  van_name: string;
}

export interface IVanHost {
  id: number | string;
  sublocation_price: SubPrice[];
  first_name: string;
  last_name: string;
  photo: string;
  email?: string;
  phone?: string;
  feedback: IHostFeedback[];
  created_at: string;
  description: string;
  host_tag: string[];
  state: string;
  city: string;
  has_insurance: boolean;
}

export interface HostState {
  host?: IVanHost;
  isLoading: {
    get: boolean;
  };
  result: {
    get?: number | string;
  };
}

export interface RequestHostAction {
  type: HostActionEnum.REQUEST_HOST;
  id: string;
}

export interface ResultHostAction {
  type: HostActionEnum.RESULT_HOST;
  data: IVanHost;
  status: string | number;
}

export type HostAction = RequestHostAction | ResultHostAction;
